import script from "./myViewMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./myViewMedia.vue?vue&type=script&setup=true&lang=js"

import "./myViewMedia.vue?vue&type=style&index=0&id=4e5371c3&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5371c3"]])

export default __exports__